import {calculateByIncome, rewriteApiData} from '../../services/apiHelper'
import {
  calculateMonthlyCostsByMortgage,
  calculateYearlyIncome,
  calculateYearlyIncomeIndependentApi,
  CanIAffordThisHouseApi,
  getBanksApi,
  getMortgageProvider,
  getMortgageProviders,
  getNhg,
  getSummaryPdf,
  sharePdfViaEmail
} from '../../services/calculationsApi'
import {store} from '../../index'
import {
    SET_FIELD,
    GET_BANK_BY_ID,
    CALCULATE,
    CALCULATE_INCOME,
    CALCULATE_YEARLY_INCOME,
    CALCULATE_YEARLY_INCOME_INDEPENDENT,
    GET_MORTGAGE_PROVIDER,
    GET_SUMMARY_PDF,
    SHARE_PDF
} from '../actionTypes/calculatorActionTypes'
import {removeDotsComas} from "../../services/helpers";

export const parseSearchQuery = (searchString, clean) => {
    const result = {};
    const entries = new URLSearchParams(searchString).entries();

    for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        result[key] = checkValueForCurrency(value, key);

        if(clean) {
          if (result.hasOwnProperty('share')) {
            delete result[`share`];
          }
          // remove debug type param
          if (result.hasOwnProperty('type')) {
            delete result[`type`];
          }
        }
    }

    return Object.keys(result).length === 0 ? null : result;
};

const checkValueForCurrency = (value, key) => {
    return value;
    /*let tmp;
    switch (key) {
        case 'Klant_Jaarinkomen':
        case 'Onderpand_Koopsom':
        case 'Partner_Jaarinkomen':
            tmp = (value) ? '€ ' + value : value;
        break;
        default:
            tmp = value;
        break;
    }

    return tmp;*/
}

export const setField = (field, value) => {
    return {
        type: SET_FIELD,
        field,
        value
    };
};

export const getMortgageProviderAction = (id, isnewbuilding, energyLabel) => {
    return async (dispatch) => {

        const mortgageProvider = await getMortgageProvider(id, isnewbuilding, energyLabel.value);

        if(typeof store.getState().calculator?.SelectedMortgageProvider?.initial === "undefined") {
          const mortgageProvidersNhg = await getMortgageProviders(mortgageProvider.hypotheekVorm, isnewbuilding, 0, mortgageProvider.rentevastePeriode, energyLabel);
          const nhgLookupId = mortgageProvidersNhg.producten.find((p) => p.aanbiederId === mortgageProvider.aanbiederId)?.lookupId;
          const isNhg = nhgLookupId === mortgageProvider.lookupId

          // all producten ophalen voor renteBasis 100
          const mortgageProviders100 = await getMortgageProviders(mortgageProvider.hypotheekVorm, isnewbuilding, 100, mortgageProvider.rentevastePeriode, energyLabel);
          let nonNhgLookupId = mortgageProviders100.producten.find((p) => p.aanbiederId === mortgageProvider.aanbiederId)?.lookupId;
          if (typeof nonNhgLookupId === "undefined") {
            let mainBank = mortgageProviders100.producten.sort((a, b) => a.rentestand - b.rentestand)[0];
            nonNhgLookupId = mainBank?.lookupId;
          }

          mortgageProvider.initial = {
            isNhg: isNhg,
            nhglookupId: nhgLookupId,
            nonNhgLookupId: (nonNhgLookupId) ? nonNhgLookupId : nhgLookupId
          }
        }

        dispatch({
            type: GET_MORTGAGE_PROVIDER,
            response: mortgageProvider
        })
    }
}


export const affordCalcAction = (stepNumber, useBestDealInterest, getMonthlyCost) => {
    return async (dispatch) => {
        const cleanData = removeDotsComas(store.getState().calculator);

        if (useBestDealInterest) {
            cleanData.Interest = cleanData.InterestBestDeal;
        }

        if (cleanData.Interest <= 0 || !cleanData.Interest) {
          let riskClass = 0;
          const nhg = await getNhg();
          if (parseInt(nhg.existingBuilding) <= parseInt(cleanData.Woning)) {
            riskClass = 101;
          }
          const providers = await getMortgageProviders('Annuïteitenhypotheek', false, riskClass, 10, cleanData.EnergyLabel);
          cleanData.Interest = providers.producten[0].rentestand;
          dispatch(setField('Interest', cleanData.Interest));
        }
        let calculatedData = await CanIAffordThisHouseApi(cleanData);
        if(calculatedData?.error) {
            dispatch(setField('error', calculatedData?.error));
            return;
        }
        calculatedData.maxMortgageAmount = calculatedData.customerMaximumMortgageAmount;
        calculatedData.netMonthlyCostHouse = calculatedData.netMonthlyCost;
        calculatedData.grossMonthlyCostHouse = calculatedData.grossMonthlyCost;

        // if we need the monthlyCost for the calculatedData.customerMaximumMortgageAmount
        // this is done when the mortgage history questions are filled in
        // only then does the maxMortgageAmount differ
        if(getMonthlyCost) {
            cleanData.maxMortgageAmount = calculatedData.maxMortgageAmount;
            await calculateMonthlyCostsByMortgage(cleanData).then((result) => {
                calculatedData.netMonthlyCost = result.netMonthlyCost;
                calculatedData.grossMonthlyCost = result.grossMonthlyCost;
                //console.log(result)
            });
        } else {
            // else we delete, since it is retrieved by
            delete calculatedData.customerMaximumMortgageAmount;
            delete calculatedData.netMonthlyCost;
            delete calculatedData.grossMonthlyCost;
        }

        calculatedData = rewriteApiData(cleanData, calculatedData);


        dispatch({
            type: CALCULATE,
            response: calculatedData,
            stepNumber,
        })
    }
};


export const mortgageCalcAction = (useBestDealInterest) => {
    return async (dispatch) => {
        const cleanData = removeDotsComas(store.getState().calculator);
        if (useBestDealInterest) {
          cleanData.Interest = cleanData.InterestBestDeal;
        }
        let calculatedData = await calculateByIncome(cleanData);
        if(calculatedData?.error) {
            dispatch(setField('error', calculatedData?.error));
            return;
        }


        calculatedData = rewriteApiData(cleanData, calculatedData);

        dispatch({
            type: CALCULATE_INCOME,
            response: calculatedData
        })
    }
};




export const calculateYearlyIncomeAction = (data, field) => {
    return async (dispatch) => {
        const calculatedData = await calculateYearlyIncome(data);
        if(calculatedData?.error) {
            dispatch(setField('error', calculatedData?.error));
            return;
        }
        dispatch({
            type: CALCULATE_YEARLY_INCOME,
            response: calculatedData,
            field
        })
    }
};

export const getSummaryPdfAction = (data, locale) => {
    return async (dispatch) => {
      if (locale === "en") {
        data.language = locale
      }
        const pdfData = await getSummaryPdf(data);

        dispatch({
            type: GET_SUMMARY_PDF,
            response: pdfData
        })
    }
};

export const sharePdfAction = (data, locale) => {
  if (locale === "en") {
    data.language = locale
  }
    return async (dispatch) => {
        const sharePdf = await sharePdfViaEmail(data);

        dispatch({
            type: SHARE_PDF,
            response: sharePdf
        })
    }
};


export const calculateYearlyIncomeIndependentAction = (data, field) => {
    return async (dispatch) => {
        const calculatedData = await calculateYearlyIncomeIndependentApi(data);

        dispatch({
            type: CALCULATE_YEARLY_INCOME_INDEPENDENT,
            response: calculatedData,
            field
        })
    }
};


export const getBankByIdAction = () => {
    return async (dispatch) => {
        const bankIds = ["AA", "RB", "IN"];
        const state = store.getState().calculator;
        const bankData = await getBanksApi(state, state.response);

        const banksList = bankData.producten.filter((item) => {
            return bankIds.includes(item.aanbiederId);
        });

        let mainBank = bankData.producten.sort((a, b) => a.rentestand - b.rentestand)[0];
        if (store.getState().calculator.SelectedMortgageProvider) {
            mainBank = store.getState().calculator.SelectedMortgageProvider;
        }

        const uniqueBanks = banksList.reduce((uniq, item) => uniq.some(({ aanbiederId }) => aanbiederId === item.aanbiederId) ? uniq : [...uniq, item], []);
        const { Woning } = store.getState().calculator;
        for (const uniqueBank of uniqueBanks) {
          if (Woning > 0) {
            uniqueBank.response = await CanIAffordThisHouseApi(removeDotsComas(store.getState().calculator), uniqueBank.rentestand);
          } else {
            uniqueBank.response = await calculateMonthlyCostsByMortgage(removeDotsComas(store.getState().calculator), uniqueBank.rentestand, (state.Woning > 0) ? state.Woning : state.response.maxMortgageAmount);
          }
        }

        dispatch({
            type: GET_BANK_BY_ID,
            bankData : {
                mainBank,
                otherBanks: uniqueBanks,
                allBanks: bankData.producten
            }
        });

        window.scrollTo(0, 0);
    }
};
